import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { themed } from '@indeed/ifl-css';
import { StyledDetails } from './Details.js';
import { forwardRef, useState, useEffect } from 'react';
import { DetailsGroupContext } from './useDetailsGroupContext.js';
import { useCollection } from '../../hooks/useCollection.js';
import { sanitizeSx } from '../../utils/sanitizeSx.js';
import { jsx } from '@emotion/react';
import '../../index-D7dZz-Df.js';
import '@indeed/ifl-icons';
import '../../utils/createResponsive.js';
import '@indeed/ihl-use-id';
import '../../hooks/useMergeRefs.js';
import '../../utils/warn.js';
import '../Divider/Divider.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../Text/Text.js';
import '../Box/Box.js';

const StyledDetailsGroup = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  shouldForwardProp: prop => prop !== "heading" && prop !== "activeIndices" && prop !== "defaultActiveIndices",
  target: "enlgwbj0"
} : {
  styleProps: [],
  shouldForwardProp: prop => prop !== "heading" && prop !== "activeIndices" && prop !== "defaultActiveIndices",
  target: "enlgwbj0",
  label: "StyledDetailsGroup"
})(() => {
  return {
    inlineSize: "100%"
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DetailsGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    size = "md",
    defaultActiveIndices,
    activeIndices,
    onActiveIndicesChange,
    dividers = true,
    sx,
    ...props
  } = _ref;
  const replacedStyles = sanitizeSx(sx ?? {}, "details", `${StyledDetails}`) ?? {};
  const {
    registerItem,
    getItemIndexById,
    getItemCount
  } = useCollection();
  const [openItems, setOpenItems] = useState(defaultActiveIndices !== undefined ? defaultActiveIndices : activeIndices !== undefined ? activeIndices : []);
  const handleOnChange = newIndices => {
    if (activeIndices && activeIndices.length) {
      setOpenItems(activeIndices);
      if (onActiveIndicesChange) {
        onActiveIndicesChange(newIndices); // for controlled behavior
      }
      return;
    }
    setOpenItems(newIndices);
    if (onActiveIndicesChange) {
      onActiveIndicesChange(newIndices);
    }
  };
  useEffect(() => {
    if (activeIndices && activeIndices !== openItems) {
      setOpenItems(activeIndices);
      return;
    }
  }, [activeIndices, openItems]);
  const context = {
    openItems,
    handleOnChange,
    registerItem,
    getItemIndexById,
    getItemCount,
    contextSize: size,
    dividers
  };
  return jsx(DetailsGroupContext.Provider, {
    value: context
  }, jsx(StyledDetailsGroup, _extends({
    ref: ref,
    sx: replacedStyles
  }, props), children));
});
DetailsGroup.displayName = "DetailsGroup";

export { DetailsGroup, StyledDetailsGroup };
